import { LOCATION_CHANGE } from 'react-router-redux';

import * as D from '../../deps';
import * as Workers from '../workers';

export default [
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.APPEND_ITEMS,
    handler: Workers.appendItemsToPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.ANNOTATE_PLAYLISTS,
    handler: Workers.annotatePlaylists,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.CREATE_PLAYLIST,
    handler: Workers.createPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.DELETE_PLAYLIST,
    handler: Workers.deletePlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.CONFIRM_DELETE_PLAYLIST,
    handler: Workers.confirmDeletePlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.DELETE_TRACK,
    handler: Workers.deleteTrackFromPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.GET_PLAYLIST_AUTOFILL_TRACKS,
    handler: Workers.getAutofillTracksForPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.GET_PLAYLIST_RECOMMENDATIONS,
    handler: Workers.getRecommendationsForPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.GET_TRACKS,
    handler: Workers.getTracksForPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.INSERT_TRACK,
    handler: Workers.insertTrackInPlaylist,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.MOVE_TRACK,
    handler: Workers.moveTrackInPlaylist,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.PLAYLISTS_CREATE_SUCCESS,
    handler: Workers.redirectToNewPlaylist,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.COLLECTIONS_REMOVE_ITEM_SUCCESS,
    handler: Workers.redirectToMyMusicPlaylistPage,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.SET_DETAILS,
    handler: Workers.setPlaylistDetails,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.PlaylistT3.ActionTypes.UNLOCK_PLAYLIST_AND_NOTIFY,
    handler: Workers.unlockPlaylistAndNotify,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK,
    handler: Workers.preUpdatePlaylistForFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.ADD_TRACK_FEEDBACK,
    handler: Workers.preUpdatePlaylistForFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.PLAYLISTS_GET_TRACKS_SUCCESS,
    handler: Workers.handleOutOfSyncUpdatesForLinkedPlaylists,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE,
    handler: Workers.onTrackStarted,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.App.AppActions.PAGE_VISIBILITY_DID_CHANGE,
    handler: Workers.onVisibilityChange,
    concur: 'takeOnlyWithWait',
    wait: 10800000, // 3 hours in ms
  },
  {
    actionType: LOCATION_CHANGE,
    handler: Workers.onLocationChange,
    concur: 'takeEvery',
  },
];
